<template>
    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <addCustomer></addCustomer>
    </v-dialog>
</template>

<script>
    import addCustomer from '../Shared/AddCustomer.vue'

    // Settings Types
    import {
        Customer
    } from '../../store/namespace-helper'

    export default {
      name: 'add-new-customer',
      components: {
        addCustomer
      },
      data () {
        return {
        }
      },
      methods: {
      },
      computed: {
        dialog () {
          return this.$store.getters[Customer.getters.getOpenNewCustomerDialogState]
        }
      },
      beforeDestroy () {

      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Customers/AddCustomerDialog.vue